import { generateUtilityClass, generateUtilityClasses } from '@mui/material';

export function getUtilityClass(slot: string): string {
  return generateUtilityClass('Badge', slot);
}

// classes export 유지 (target으로 사용됨)
export const badgeClasses = generateUtilityClasses('Badge', [
  'root',
  'label',
  'filledGray',
  'filledRed',
  'filledOrange',
  'filledYellow',
  'filledGreen',
  'filledLightGreen',
  'filledSky',
  'filledBlue',
  'filledPurple',
  'filledMagenta',
  'filledBrand',
  'filledInverse',
  'filledBlack',
  'filledLightGray',
  'tintGray',
  'tintRed',
  'tintOrange',
  'tintYellow',
  'tintGreen',
  'tintLightGreen',
  'tintSky',
  'tintBlue',
  'tintPurple',
  'tintMagenta',
  'tintBrand',
  'tintInverse',
  'tintBlack',
  'tintLightGray',
  'outlineGray',
  'outlineRed',
  'outlineOrange',
  'outlineYellow',
  'outlineGreen',
  'outlineLightGreen',
  'outlineSky',
  'outlineBlue',
  'outlinePurple',
  'outlineMagenta',
  'outlineBrand',
  'outlineInverse',
  'outlineBlack',
  'outlineLightGray',
  'ghostGray',
  'ghostRed',
  'ghostOrange',
  'ghostYellow',
  'ghostGreen',
  'ghostLightGreen',
  'ghostSky',
  'ghostBlue',
  'ghostPurple',
  'ghostMagenta',
  'ghostBrand',
  'ghostInverse',
  'ghostBlack',
  'ghostLightGray',
  'disabled',
  'startIcon',
  'endIcon',
  'shapeRectangular',
  'shapeCircular',
]);

// theme 등록 완전 제거 (styleOverrides가 모두 컴포넌트로 이전되었음)
// export const badgeThemes는 더 이상 필요 없음
